/**
 * Lightweight localStorage cache for onboarding completion.
 *
 * Onboarding completion is monotonic - once a user finishes onboarding
 * (`onboardPricing === true`) they never revert - so caching only the positive
 * "complete" state is safe. The route gate uses this to render content instantly
 * for returning users while it revalidates the profile in the background, instead
 * of blocking first paint on a callable round-trip.
 */

const ONBOARDING_COMPLETE_PREFIX = "braiv:onboardingComplete:";

function getKey(uid: string): string {
    return `${ONBOARDING_COMPLETE_PREFIX}${uid}`;
}

export function readOnboardingComplete(uid: string | null | undefined): boolean {
    if (typeof window === "undefined" || !uid) return false;
    try {
        return window.localStorage.getItem(getKey(uid)) === "1";
    } catch (error) {
        console.warn("Failed to read onboarding completion cache:", error);
        return false;
    }
}

export function writeOnboardingComplete(uid: string | null | undefined): void {
    if (typeof window === "undefined" || !uid) return;
    try {
        window.localStorage.setItem(getKey(uid), "1");
    } catch (error) {
        console.warn("Failed to write onboarding completion cache:", error);
    }
}
